<div class="td-wb-notifications-toast-container"
     role="region"
     aria-labelledby="td-wb-aria-trade-notification-header">
  <h2 class="td-wb-vh"
      id="td-wb-aria-trade-notification-header"
      translate="tdWb.notifications.NOTIFICATIONS_HEADER_ARIA"></h2>
  @if (toasts=== undefined || toasts.length === 0) {
    <span class="td-wb-vh"
          translate="tdWb.notifications.EMPTY_NOTIFICATIONS_ARIA"></span>
  }
  @for (toast of toasts; track trackByNotifications($index, toast)) {
    <div role="alert">
      <td-wb-notification-toast-wrapper class="td-wb-notifications-toast-container__toast"
                                        [ngClass]="{ 'td-wb-notifications-toast-container__toast--large': toast.hasLargeContent}"
                                        [@easeInOutAnimation]
                                        [toast]="toast"
                                        [expiryDuration]="expiryDuration"
                                        (onClose)="closeToast($event)" />
    </div>
  }
  @if (excessMessageCount > 0) {
    <td-wb-notification-toast-wrapper class="td-wb-notifications-toast-container__toast td-wb-notifications-toast-container__toast--excess"
                                      [@easeInOutAnimation]
                                      [toast]="excessToast"
                                      [expiryDuration]="expiryDuration"
                                      [excessMessageCount]="excessMessageCount"
                                      (onClose)="closeToast($event)" />
}
</div>
